import React, { useEffect, useState } from "react";
import { apiGet, apiPost } from "../../../services/api";
import Button from "../../common/Button";

type ProsthoCase = {
  id: number;
  patient_name: string;
  patient_id: string;
  patient_phone?: string;
  teeth: string | null;
  stage: string;
  status: string;
  notes?: string;
  created_at: string;
  origin_procedure?: string;
};

export default function FpdCasesWidget() {
  const [cases, setCases] = useState<ProsthoCase[]>([]);
  const [loading, setLoading] = useState(true);

  const loadData = async () => {
    try {
      const data = await apiGet("/api/treatments/prostho/cases?type=FPD&status=Active");
      setCases(Array.isArray(data) ? (data as ProsthoCase[]) : []);
    } catch (e) {
      console.error("Failed to load FPD cases", e);
      setCases([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const updateStatus = async (caseId: number, status: "Pending" | "In Progress" | "Completed") => {
    try {
      await apiPost(`/api/treatments/prostho/cases/${caseId}/update`, { status });
      loadData();
    } catch {
      alert("Failed to update case");
    }
  };

  return (
    <div style={{ background: '#f8fafc', borderRadius: '14px', padding: '20px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', gap: '16px', height: '100%' }}>
      <h3 style={{ margin: 0, fontSize: '1.05rem', color: 'var(--mod-text-main)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        FPD Cases (Active)
        <span style={{ background: '#e0f2fe', color: '#0369a1', padding: '2px 10px', borderRadius: '12px', fontSize: '0.8rem' }}>{cases.length}</span>
      </h3>
      
      <div style={{ flex: 1, overflowY: "auto", display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {loading ? (
          <div style={{ color: "var(--mod-text-muted)", fontSize: "0.9rem" }}>Loading cases...</div>
        ) : cases.length === 0 ? (
          <div className="mod-empty-state" style={{ padding: '20px', border: '1px dashed #cbd5e1', background: 'transparent', height: 'auto' }}>
            <p style={{ margin: 0, fontSize: '0.9rem' }}>No active FPD cases found.</p>
          </div>
        ) : (
          cases.map((c) => (
            <div key={c.id} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: '12px', padding: '16px', boxShadow: 'var(--mod-shadow-sm)' }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: '8px' }}>
                <strong style={{ fontSize: "1rem", color: 'var(--mod-text-main)' }}>{c.patient_name}</strong>
                <span style={{ fontSize: "0.75rem", background: c.status === 'Pending' ? '#fef3c7' : '#d1fae5', color: c.status === 'Pending' ? '#d97706' : '#059669', padding: "4px 8px", borderRadius: "6px", fontWeight: 700 }}>
                  {c.status}
                </span>
              </div>

              <div style={{ fontSize: "0.85rem", color: "var(--mod-text-muted)", marginBottom: '4px' }}>
                ID: {c.patient_id} • 📞 {c.patient_phone || "—"}
              </div>
              <div style={{ fontSize: "0.85rem", color: "var(--mod-text-muted)", marginBottom: '12px' }}>
                Teeth: {c.teeth || "N/A"} • {new Date(c.created_at).toLocaleDateString()}
              </div>

              <div style={{ display: "flex", gap: '8px', flexWrap: "wrap" }}>
                {c.status === "Pending" && (
                  <Button variant="primary" size="sm" onClick={() => updateStatus(c.id, "In Progress")}>
                    Mark In Progress
                  </Button>
                )}
                {c.status !== "Completed" && (
                  <Button variant="secondary" size="sm" onClick={() => updateStatus(c.id, "Completed")} style={{ color: '#16a34a', borderColor: '#bbf7d0', background: '#f0fdf4' }}>
                    Mark Completed
                  </Button>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

